import clsx from 'clsx';
import { FC } from 'react';
import { IModalDefault } from '../../types';
import ModalBase from './base';
import styles from './styles.module.css';

const ModalDefault: FC<IModalDefault> = (props) => {

  const {
    isOpen,
    title,
    contentProps = {},
    children,
    ...rest
  } = props;

  const { className: contentClass = '', ...contentRest } = contentProps;

  return (
    <ModalBase
      isOpen={isOpen}
      {...rest}
    >

      {Boolean(title) && (
        <div className={styles.header}>
          {title}
        </div>
      )}

      <div className={clsx(styles.content, contentClass)} {...contentRest}>
        {children}
      </div>

    </ModalBase>
  );

};

export default ModalDefault;
